import { toast } from "sonner";

export const STARTER = "baby_barnes";

// 1 coin per 100 points; any completed exercise with points earns at least 1 coin.
export const coinsFor = (score) => (score > 0 ? Math.max(1, Math.floor(score / 100)) : 0);

export const walletOf = (stats = {}) => ({
  coins: stats.coins || 0,
  earned: stats.coins_earned_total || 0,
  owned: stats.avatars_owned?.length ? stats.avatars_owned : [STARTER],
  avatar: stats.avatar || STARTER,
  bg: stats.avatar_bg || "galaxy",
});

// Returns a new stats object with coins awarded for `score`; shows a toast.
export function awardCoins(stats = {}, score, label = "drill") {
  const n = coinsFor(score);
  if (n > 0) toast.success(`+${n} coin${n === 1 ? "" : "s"} for the ${label}`, { description: "Spend them in the Avatar Shop", duration: 2500 });
  return { ...stats, coins: (stats.coins || 0) + n, coins_earned_total: (stats.coins_earned_total || 0) + n };
}

export function buyAvatar(stats = {}, avatar) {
  const w = walletOf(stats);
  if (w.owned.includes(avatar.id)) return { ok: false, reason: "Already owned" };
  if (w.coins < avatar.price) return { ok: false, reason: `Need ${avatar.price - w.coins} more coins` };
  return { ok: true, stats: { ...stats, coins: w.coins - avatar.price, avatars_owned: [...w.owned, avatar.id], avatar: avatar.id } };
}
